import { useDemandedDocumentsContext } from '../context/DemandedDocumentsContext';
import type {
    SchemaDemandedDocumentEntry,
    SchemaDemandedDocumentsKeys,
} from '~/features/leadDetails/schemas/demandedDocuments.schema';

const useDemandedDocuments = () => {
    const { attribution, demandedDocuments, resetCount, resetDemandedDocuments, setAttribution, setDemandedDocuments } =
        useDemandedDocumentsContext();

    const setDemandDocuments = (path: SchemaDemandedDocumentsKeys, documents: SchemaDemandedDocumentEntry[]) => {
        setDemandedDocuments((prev) => ({
            ...prev,
            [path]: documents,
        }));
    };

    const updateDemandDocument = (path: SchemaDemandedDocumentsKeys, name: string, requested: boolean) => {
        if (name.trim().length === 0) return;
        setDemandedDocuments((prev) => {
            // eslint-disable-next-line no-restricted-syntax
            for (const [key, documentEntry] of Object.entries(prev)) {
                const index = documentEntry.findIndex((entry) => entry.name === name);

                // eslint-disable-next-line no-continue
                if (index === -1) continue; // continues the loop if a name is not found

                const updatedDocumentEntry = [...documentEntry];
                updatedDocumentEntry[index] = { ...updatedDocumentEntry[index], requested };
                return {
                    ...prev,
                    [key]: updatedDocumentEntry,
                };
            }

            return {
                ...prev,
                [path]: [
                    ...prev[path],
                    {
                        name,
                        requested,
                    },
                ],
            };
        });
    };

    const removeDemandDocument = (path: SchemaDemandedDocumentsKeys, name: string) => {
        setDemandedDocuments((prev) => {
            const removeIndex = prev[path].findIndex((entry) => entry.name === name);

            if (removeIndex === -1) return prev;

            const updatedDocuments = [...prev[path]];
            updatedDocuments.splice(removeIndex, 1);

            return {
                ...prev,
                [path]: updatedDocuments,
            };
        });
    };

    return {
        attribution,
        demandedDocuments,
        removeDemandDocument,
        resetCount,
        resetDemandedDocuments,
        setAttribution,
        setDemandDocuments,
        updateDemandDocument,
    };
};

export default useDemandedDocuments;
